window.slate = window.slate || {};
window.theme = window.theme || {};


/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '$';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format, decimal) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);
    var decimal = decimal || 2;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, decimal);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, decimal, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * Filter  Script
 * ------------------------------------------------------------------------------
 * Will triggers <select> changes on collection and cart pages.
 *
 * @namespace filters
 */
 
slate.Filters = (function() {
	var constants = {
		SORT_BY: 'sort_by'
	};
	var selectors = {
		filterSelection			: '[filters-filter]',
		sortSelection			: '[filters-sort]',
		defaultSort				: '[filters-default-sort]'
	};
	
	/**
	 * Filters constructor. 
	 * @param {string} container - selector for the section container DOM element
	 */
	function Filters(container) {
		this.$container = this.$container = $(container);

	    this.$filterSelect = $(selectors.filterSelection, this.$container);
	    this.$sortSelect = $(selectors.sortSelection, this.$container);
	    this.$selects = $(selectors.filterSelection, this.$container).add($(selectors.sortSelection, this.$container));
	
	    this.defaultSort = this._getDefaultSortValue();
	    this.$selects.removeClass('hidden');
	
	    this.$filterSelect.on('change', this._onFilterChange.bind(this));
	    this.$sortSelect.on('change', this._onSortChange.bind(this));
	}
	
	
	Filters.prototype = $.extend({}, Filters.prototype, {
		_onSortChange: function(evt) {
			var sort = this._sortValue();
			if (sort.length) {
				window.location.search = sort;
			} else {
				// clean up our url if the sort value is blank for default
				window.location.href = window.location.href.replace(window.location.search, '');
			}
		},
		
		_onFilterChange: function(evt) {
			window.location.href = this.$filterSelect.val() + window.location.search;
		},
		
		_getSortValue: function() {
			return this.$sortSelect.val() || this.defaultSort;
		},
		
		_getDefaultSortValue: function() {
			return $(selectors.defaultSort, this.$container).val();
		},
		
		_sortValue: function() {
			var sort = this._getSortValue();
			var query = '';
		
			if (sort !== this.defaultSort)
				query = constants.SORT_BY + '=' + sort;
				
			return query;
		}
	});
	
	return Filters;
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
	 * @namespace product
*/

theme.Product = (function() {

	var selectors = {
		addToCart				: '[data-add-to-cart]',
		addToCartText			: '[data-add-to-cart-text]',
		comparePrice			: '[data-compare-price]',
		comparePriceText		: '[data-compare-text]',
		originalSelectorId		: '[data-product-select]',
		priceWrapper			: '[data-price-wrapper]',
		productJSON				: '[data-product-json]',
		productPrice			: '[data-product-price]',
		discountedPrice			: '[data-discounted-price]',
		singleOptionSelector	: '[data-single-option-selector]',
		metafieldsSections		: 'section.product-details',
		quantity				: '#Quantity',
		perQtyUnit				: '[data-qty-unit]',
		perUnit					: '[data-per-unit]',
		variantTitle			: 'meta[itemprop="name"]',
		minQty					: '[data-min-qty]',
		qtyWarning				: '[data-qty-warning]',	
		variantSKU				: '[data-variant-sku]',
		cartJSON				: '[data-cart-json]',
	};

	/**
	 * Product section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	 */
	function Product(container) {
		this.$container = $(container);

		// Stop parsing if we don't have the product json script tag when loading
		// section in the Theme Editor
		if (!$(selectors.productJSON, this.$container).html()) {
			return;
		}
 
		var sectionId = this.$container.attr('data-section-id');
		this.productJSON = JSON.parse($(selectors.productJSON, this.$container).html());
		this.cartJSONhtml = $(selectors.cartJSON, this.$container);
		this.cartJSON = JSON.parse(this.cartJSONhtml.html());

		var options = {
			$container: this.$container,
			enableHistoryState: this.$container.data('enable-history-state') || false,
			singleOptionSelector: selectors.singleOptionSelector,
			originalSelectorId: selectors.originalSelectorId,
			product: this.productJSON
		};

		this.settings 				= {};
		this.namespace 				= '.product';
		this.variants 				= new slate.Variants(options);
		this.$addToCartBtn 			= $(selectors.addToCart, this.$container);
		this.$addToCartTxt 			= $(selectors.addToCartText, this.$container);
		this.$metafieldsSections 	= $(selectors.metafieldsSections, this.$container);
		this.$quantity 				= $(selectors.quantity, this.$container);
		this.$productPrice			= $(selectors.productPrice, this.$container);
		this.$perQtyUnit			= $(selectors.perQtyUnit, this.$container);
		this.$perUnit 				= $(selectors.perUnit, this.$container);
		this.$minQty 				= $(selectors.minQty, this.$container);
		this.$variantTitle 			= $(selectors.variantTitle, this.$container);
		this.variantSKU				= $(selectors.variantSKU, this.$container);
		
		// UNITS
		this.units = {
			substrate: 	{ panel: 'each', roll: 'per linear foot', default: '', panel_qty: '(each)', roll_qty: '(linear feet)' },
			ink: 		{ default: 'per gram' }
		}
		
		// DISCOUNT RULES (Replicate Shopify Script logic)
		// ### RULES ###
		// ### INKS
		this.INKS_THRESHOLDS = [
			{
				grams: 1000, 	// Grams
				discount: 20	// Percent
			}
		];
		
		// ### SUBSTRATES
		this.SUBSTRATES_THRESHOLDS = [
			{
				spend: 150000,	// Spend amount (in cents)
				discount: 5		// Percent
			},
			{
				spend: 200000,	// Spend amount (in cents)
				discount: 10	// Percent
			}
		];

		this.$container.on('variantChange' + this.namespace, function(e) {
			this.updateAddToCartState(e);
			this.displayQuantity(e);
			this.displayUnits(e);
			this.applyTieredPricing(e);
		}.bind(this));
		this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
		this.$addToCartBtn.on('click' + this.namespace, this.AddToCartHandler.bind(this));
		this.$quantity.on('change', function(e) {
			this.applyTieredPricing( { variant: this.variants.currentVariant } );
			this.AddToCartHandler(); 
		}.bind(this));


		
		// INIT
		this.updateCartJSON(); // Force JSON cart to update (back button issue)
		this.displayUnits( { variant: { title: this.$variantTitle.attr('content') } } );
		this.applyTieredPricing( { variant: this.variants.currentVariant } ); 
	}

	Product.prototype = $.extend({}, Product.prototype, {
		/**
		 * Updates the DOM state of the add to cart button
		 *
		 * @param {boolean} enabled - Decides whether cart is enabled or disabled
		 * @param {string} text - Updates the text notification content of the cart
		 */
		updateAddToCartState: function(e) {
			var variant = e.variant;

			if (variant) {
				$(selectors.priceWrapper, this.$container).removeClass('hide');
				this.$addToCartBtn.data('variant-id', variant.id);
				this.variantSKU.html(variant.sku);
				// Display metafields
				this.displayVariantMetafields(variant.id);
			} else {
				this.$addToCartBtn.prop('disabled', true);
				this.$addToCartTxt.html(theme.strings.unavailable);
				$(selectors.priceWrapper, this.$container).addClass('hide');
				return;
			}

			if (variant.available) {
				this.$addToCartBtn.prop('disabled', false);
				this.$addToCartTxt.html(theme.strings.addToCart);
				this.$addToCartBtn.data('variant-id', variant.id);
			} else {
				this.$addToCartBtn.prop('disabled', true);
				this.$addToCartTxt.html(theme.strings.soldOut);
			}
		},
		
		/**
		 * Add to Cart Click Handler
		 *
		 * @param {Object} e
		 *
		**/
		AddToCartHandler: function(e) {	
			var $qtyWarning = $(selectors.qtyWarning, this.$container);
			$qtyWarning.addClass('off');
				
			// Stop the process if the future quantity will
			// Exceed the max possible quantity
			if (this.checkIsMaxQuantity()) {
				if (e) e.preventDefault();
				
				// Display error Message
				$qtyWarning.removeClass('off');
			}
		},

		/**
		 * Updates the DOM with specified prices
		 *
		 * @param {string} productPrice - The current price of the product
		 * @param {string} comparePrice - The original price of the product
		 */
		updateProductPrices: function(e) {
			var variant = e.variant;
			var $comparePrice = $(selectors.comparePrice, this.$container);
			var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

			this.$productPrice
				.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

			if (variant.compare_at_price > variant.price) {
				$comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
				$compareEls.removeClass('hide');
			} else {
				$comparePrice.html('');
				$compareEls.addClass('hide');
			}
		},
		
		/**
		 * Display the Metafields section
		 * related to the variant
		**/
		displayVariantMetafields: function(variant_id) {
			this.$metafieldsSections.addClass('d-none');
			this.$metafieldsSections.filter('[data-variant-id="'+variant_id+'"]').removeClass('d-none')
		},
		
		/**
		 * Display units based on
		 * Template and variant name
		 * @param {Object} e
		**/
		displayUnits: function(e) {
			var variant = e.variant, html = '', product_template = window.product_template, variant_title = '';
			
			// No template defined return
			if (!product_template) return;
			
			// To Lowecase
			if (!variant.title) return;
			variant_title = variant.title.toLowerCase();
			
			// INK tempalte
			if (product_template == 'ink')
				this.$perUnit.text( this.units.ink.default );
			
			// SUBSTRATE template
			if (product_template == 'substrate') {
				if (variant_title.indexOf('panel') !== -1 ) {
					this.$perUnit.text( this.units.substrate.panel );
					this.$perQtyUnit.text( this.units.substrate.panel_qty );
				} else if (variant_title.indexOf('roll') !== -1 ) {
					this.$perUnit.text( this.units.substrate.roll );
					this.$perQtyUnit.text( this.units.substrate.roll_qty );
				} else {
					this.$perUnit.text( this.units.substrate.default );
				}
			}
		},
		
		/**
		 * Display quantity select
		 * for each variant
		 * + min quiantity order sentence
		 *
		 * @param {Object} e
		 *
		**/
		displayQuantity: function(e) {
			var variant = e.variant
			  html = '', q_val = 100, q_increment = 100, data = null, limit = 10*q_increment;
			
			// Test object
			if (jQuery.isEmptyObject(variant_data)) return;
			
			// Test variant has data
			if (typeof variant_data[variant.id] == 'undefined') return;
			
			// assign current variant
			data = variant_data[variant.id];
			
			// Override default
			if (data.min_qty) 
				q_val = data.min_qty;
			
			// Override default	
			if (data.qty_increment) 
				q_increment = data.qty_increment;
				
			// Override default	
			limit = q_increment * 10;
			
			while ( q_val <= limit ) {
				html += '<option value="'+q_val+'">'+q_val+'</option>';
				q_val = q_val + q_increment;
			}
			
			// Update options
			this.$quantity.html(html);
			
			// Min Quantity
			this.$minQty.text(data.min_qty || 100);
		},
		
		/**
		 * Check Max 'Buyable' Quantity om Cart
		 * 
		 * @return {Boolean}
		 *
		**/
		checkIsMaxQuantity: function() {
			var select = $(selectors.originalSelectorId, this.$container), 
			  variantID = select.find('option:selected').val() 
			  qty = ~~this.$quantity.find('option:selected').val(),
			  maxQty = ~~this.$quantity.find('option:last').val(),
			  exceed = false;
			
			// Check is selected variant would end up being more than
			// the max quantity
			$.each(this.cartJSON.items, function(index, item) {
				var futureQty = ~~item.quantity + ~~qty;
				if (variantID == item.id && futureQty > maxQty) 
					exceed = true;
			});
			
			return exceed;
		},
		
		/**
		 * Update the cart JSON
		 * to prevent bug when coming back from Back button
		**/
		updateCartJSON: function() {
			$.getJSON('/cart.json', function(data) {
				this.cartJSON = data;
				this.cartJSONhtml.text( JSON.stringify(data) );
			}.bind(this));
		},
		
		/**
		 * Tiered Pricing function
		 * 
		 * @param {Object} e
		 *
		**/
		applyTieredPricing: function(e) {
			var variant = e.variant, 
			  qty = ~~this.$quantity.find('option:selected').val(),
			  discountPcent = 1;
			
			if (!variant) return;
			
			// Get the type downcased
			var type = this.downcaseString(this.productJSON.type);
			var linePrice = qty * variant.price;
			
			// INK type
			if (type && type.indexOf('ink') !== -1) {
				discountPcent = this.getInkDiscountPcent(qty);
			// SUBSTRATE TYPE
			} else if (type && type.indexOf('substrate') !== -1) {
				discountPcent = this.getSubstrateDiscountPcent(linePrice);
			}
			
			if (discountPcent !== 1)
				this.displayDiscountedPrice(variant.price, discountPcent);
			else
				this.displayDiscountedPrice(false, false);
		},
		
		/**
		 * Display discounted price
		 *
		 * @param {Float} price
		 * @param {Float} discountPcent
		 *
		**/
		displayDiscountedPrice: function(price, discountPcent) {
			$discountedPrice = $(selectors.discountedPrice, this.$container)
			
			// No Discount
			if (!price || !discountPcent) {
				this.$productPrice.removeClass('strike');
				$discountedPrice.html('');
				return;
			}
			
			var discountPrice = price * discountPcent;
			
			this.$productPrice.addClass('strike');
			$discountedPrice.html(' ' + slate.Currency.formatMoney(discountPrice, theme.moneyFormat, 2));			
		},
		
		/**
		 * Get INK product discount based on Quantity
		 * 
		 * @param {Integer} qty
		 *
		 * @return {Number}
		 *
		**/
		getInkDiscountPcent: function(qty) {			
			var pcent = 1,
			  threshold = null;
			
			// Check qty is avail
			if (!qty) return pcent;
			
			for (var threshold in this.INKS_THRESHOLDS) {
				if (qty >= this.INKS_THRESHOLDS[threshold]['grams'])
					pcent = 1 - this.INKS_THRESHOLDS[threshold]['discount']/100;
			}
			
			return pcent;
		},
		
		/**
		 * Get SUBSTRATE product discount based on Price
		 * 
		 * @param {Float} linePrice
		 *
		 * @return {Number}
		 *
		**/
		getSubstrateDiscountPcent: function(linePrice) {			
			var pcent = 1,
			  threshold = null;
			
			// Check qty is avail
			if (!linePrice) return pcent;
			
			for (var threshold in this.SUBSTRATES_THRESHOLDS) {
				if (linePrice >= this.SUBSTRATES_THRESHOLDS[threshold]['spend'])
					pcent = 1 - this.SUBSTRATES_THRESHOLDS[threshold]['discount']/100;
			}
			
			return pcent;
		},
		
		/**
		 * String to lower case
		 * 
		 * @param {String} str
		 *
		**/
		downcaseString: function(str) {
			if (!str) return false;
			return str.toLowerCase();	
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function() {
			this.$container.off(this.namespace);
		}
	});

	return Product;
})();

/**
 * Cart Page Section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the cart Section.
 * @namespace cart
**/
theme.Cart = (function() {
	var selectors = {
		cartLines					: '.cart-line',
		cartJSON					: '[data-cart-json]',
		inputUpdates				: '[name="updates[]"]',
		checkout					: 'input[name="checkout_clone"]',
		DUPONTwarning				: '[data-warning-dupont]',
		checkboxConditions			: 'input[type="checkbox"]',
		TCwarning					: '[data-warning-tc]',
		MinWarning					: '[data-warning-minimum]',
		quantity					: '[name="quantity"]',
		btnDelete					: '[data-btn-delete]',
		uploadBlock					: '[data-upload-block]'
	};
	
	
	/**
	 * Cart section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	*/
	function Cart(container) {
		this.$container 			= $(container);
		this.namespace 				= '.cart';
		var sectionId 				= this.$container.attr('data-section-id');
		this.cartJSON				= JSON.parse($(selectors.cartJSON, this.$container).html()) || false;
		
		if (this.cartJson === false) return;

		this.$checkout				= $(selectors.checkout, this.$container);
		
		this.$MinWarning			= $(selectors.MinWarning, this.$container);
		this.$checkboxConditions	= $(selectors.checkboxConditions, this.$container);
		this.$TCwarning				= $(selectors.TCwarning, this.$container);
		this.$DUPONTwarning			= $(selectors.DUPONTwarning, this.$container);
		this.userAcceptedTC			= false; // default
		this.userAcceptedDUPONT		= false; // default
		
		this.$quantity				= $(selectors.quantity, this.$container);
		this.$btnDelete				= $(selectors.btnDelete, this.$container);
		this.$inputUpdates			= $(selectors.inputUpdates, this.$container);
		this.$docUploaded			= $(selectors.uploadBlock, this.$container);
		this.$inputfile				= null;
		
		
		// Event Handlers \\
		// Accept term and conditions
		this.$checkboxConditions.on('click', this.acceptConditions.bind(this));
		// Plus Minus quantity
		this.$quantity.on('change', this.changeQty.bind(this));
		// Delete button
		this.$btnDelete.on('click', this.clickedBtnDelete.bind(this));
		// Click CHECKOUT
		this.$checkout.on('click', this.proceedToCheckout.bind(this));
		
		// INIT
		if (window.doc_page)
			this.getUploadDocPage('/products/'+window.doc_page);
		if (window.min_order_amount)
			this.minOrderMessage(window.min_order_amount);
	}
	
	
	Cart.prototype = $.extend({}, Cart.prototype, {
		
		/**
		 * Accept legal terms and conditions
		 * @param {Event} e
		**/
		acceptConditions: function(e) {
			var $target = $(e.target),
			  id = $target.attr('id');
			  
			// Terms and conditions
			if (id === 'readtc') {
				this.userAcceptedTC = ($target.prop('checked') == true);
				if (this.userAcceptedTC)
					this.$TCwarning.addClass('d-none');
			} else if (id === 'readdupont') {
				this.userAcceptedDUPONT = ($target.prop('checked') == true);
				if (this.userAcceptedDUPONT)
					this.$DUPONTwarning.addClass('d-none');
			}
		},
		
		/**
		 * Check if the cart has reach the purchase limit
		 * or disable the purchase button
		 * @param {String} min_amount
		**/
		minOrderMessage: function(min_amount) {
			if (this.cartJSON.total_price/100 < min_amount) {
				this.$MinWarning.removeClass('d-none');
				this.$checkout.attr('disabled', 'disabled')
			}
		},
		
		/**
		 * Proceed to checkout
		 * @param {Event} e
		**/
		proceedToCheckout: function(e) {
			var error = 0;
			this.$TCwarning.addClass('d-none');
			this.$DUPONTwarning.addClass('d-none');
			
			// Dupont TC accepted ?
			if (!this.userAcceptedDUPONT && this.$checkboxConditions.filter('[id="readdupont"]').length) {
				this.$DUPONTwarning.removeClass('d-none');
				error++;
			}
			
			// TC accepted ?
			if (!this.userAcceptedTC) {
				this.$TCwarning.removeClass('d-none');
				error++;
			}
			
			// Stop process on error
			if (error > 0) {
				e.preventDefault();
				return false;
			}
			
			// Disable Button
			$(e.target).attr('disabled', 'disabled');
			
			// Send form
			$('input[name="checkout"]').trigger('click');
		},
		
		/**
		 * Cart functions to update the cart 
		 * on quantity change
		 * {Event} e
		*/
		changeQty: function(e) {
			var $target = $(e.target),
			  id = $target.data('line-id'),
			  val = $target.val(),
			  $input = $('[data-qty-line-id="'+id+'"]', this.$container);
			
			$input.attr('value', val);
			$('[name="update"]').trigger('click');
		},
			
		/**
		 * Delete item button
		 * trigger link
		**/
		clickedBtnDelete: function(e) {
			e.preventDefault();
			var id = $(e.currentTarget).data('remove-line');
			window.location.href = '/cart/change?line='+id+'&amp;quantity=0';
		},
		
		/**
		 * Get upload your Tax Exemption 
		 * product data for Modal window
		**/
		getUploadDocPage: function(page) {
			$.ajax({
				url: page,
				type: 'GET'
			})
			.done(function(data) {
				var content = $(data).find('[data-section-id="doc-upload"]'),
				  title = content.find('h1').html();
				  
				$('#uploadMyDoc').on('show.bs.modal', function(e) {
					$(this).find('.modal-title').text(title);
				});
				
				// Feed modal window
				$('#product_ajax_in_cart').html('').append(content);
				
				// Start Modal Upload functions
				this.modalUploadManager();
			}.bind(this));
		},
		
		/**
		 * Modal Add Product to Cart
		 * @param {Event} e
		**/
		modalUploadManager: function() {
			var $container = $('#uploadMyDoc'),
			  $saveFileBtn = $('#saveFile', $container),
			  $innerWrapper = $('[upload-filename-wrapper]', '#uploadMyDoc'),
			  self = this;
			  
			// Set inputFile
			this.$inputfile = $('[upload-input-file]', $container);
			  
			function toggleSaveBtn() {
				$saveFileBtn.attr('disabled', function(index, attr) {
					return !(attr == 'disabled');
				});
			}
			
			// Track File input change
			this.$inputfile.on('change', function(e) {
				var fileName = '';
					
				if (e.target.value)
					fileName = e.target.value.split('\\').pop();
				
				if (fileName) {
					$('[upload-filename]', $innerWrapper).html(fileName);
					$innerWrapper.removeClass('d-none');
					toggleSaveBtn();
				}
			});
			
			// Remove File in Modal Window
			$('.icon-x', $innerWrapper).on('click', function(e) {
				this.$inputfile.val(null);
				$innerWrapper.addClass('d-none');
				toggleSaveBtn();
			}.bind(this));
			
			// Firefox bug fix
			this.$inputfile
				.on('focus', function() { self.$inputfile.addClass('has-focus'); })
				.on('blur', function() { self.$inputfile.removeClass('has-focus'); });
	
			// EVENTS
			// Update Title
			$saveFileBtn.on('click', function (e) {
				e.preventDefault();
				$(this).attr('disabled', 'disabled');
				$('#add_to_cart', $container).trigger('click');
			});
		}
		
	});
			
	return Cart;
})();
/**
 * ProductsRelated Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the ProductsRelated template.
 *
	 * @namespace ProductsRelated
*/

theme.ProductsRelated = (function() {

	var selectors = {
		productList: '[data-product-list]'
	}
	
	/**
	 * ProductsRelated section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	 */
	function ProductsRelated(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id');
		
		this.fetchProductsLimit		= 4;
		this.relatedProducts 		= [];
		this.productsData			= [];
		this.$productList			= $(selectors.productList, this.$container);
		
		// INIT
		this.init();
	}
	
	
	ProductsRelated.prototype = $.extend({}, ProductsRelated.prototype, {
		
		/**
		 * Init process
		**/
		init: function() {
			this.listToArray(window.related_products);
			
			// Fetch product data
			this.fetchProducts();
		},
		
		/**
		 * ListToArray
		 *
		 * @param {String} list
		**/
		listToArray: function(list) {
			if (!list) return;
			var arr, filtered;
			 
			arr = list.split(',');
			// Clean empty elements in the array
			filtered = arr.filter(function (el) {
				return el != null && el != "";
			});
			
			// Limit product to fetch
			this.relatedProducts = filtered.slice(
				Math.max(filtered.length - this.fetchProductsLimit, 0)
			);
		},
		
		/**
		 * Fetch products
		**/
		fetchProducts: function() {
			var self = this, 
			  calls = 0, 
			  len = this.relatedProducts.length;

			
			// Fetch products one by one
			function fetch() {;
				jQuery.getJSON("/search/suggest.json", {
					"q": self.relatedProducts.shift(),
					"resources": {
						"type": "product",
						"limit": 1,
						"options": { "fields": "title,variants.title" }
					}
				})
				.done(fetchSuccess)
				.fail(fetchFail)
			};
			
			function fetchSuccess(data) {
				calls++;
				if (self.relatedProducts.length)
					fetch();

				// Add Product data to the stack
				if (data.resources.results.products.length && (typeof data.resources.results.products[0]['title'] != 'undefined') )
					self.productsData.push(data.resources.results.products[0]);
					
				// when done start templating
				if (calls === len)
					self.templating(!!self.productsData.length);
			}
			
			function fetchFail(data) {
				calls++;
				console.log('fetchFail', data);
			}
			
			// Start loop if prodcuts
			if (this.relatedProducts.length)
				fetch();
			else	
				this.templating(false);
		},
		
		/**
		 * Templating
		 *
		 * @param {Bool} hasProducts
		**/
		templating: function(hasProducts) {
			// If NO Products to display
			if ( !hasProducts )
				return this.$productList.html( '<div class="col-12 text-lg-center px-3 py-5">'+window.no_related_products+'</div>' );

			// Data modifier 
			this.dataModifier();
			
			// Moustache
			var source 	= $('#productGridTemplate').html(),
			  template 	= Handlebars.compile(source),
			  html 		= template( { product: this.productsData, buttonText: theme.strings.buttonText } );
			
			// Add HTML
			this.$productList.html( html );
			
			// INIT SLIDER
			$('[data-mh="description"]').matchHeight();
			this.initSlider();
		},
		
		/**
		 * dataModifier
		 * Modified data - Ready for templating
		**/
		dataModifier: function() {
			for ( var d in this.productsData) {
				var body = this.productsData[d]['body'].replace(/(<([^>]+)>)/gi, '');
				this.productsData[d]['description'] = this._truncateWords(body, 25);				
			}			
		},
		
		/**
		 * Init Template slider 
		**/
		initSlider: function() {
			// Reasign DOM
			this.$productList = $(selectors.productList, this.$container);
		
			this.$productList.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true,
				arrows: false,
				initialSlide: 0,
				mobileFirst: true,
				responsive: [
					{
					  breakpoint: 992,
					  settings: 'unslick'
					}
				  ]
			});
		},
		
		/**
		 * Truncate words
		 *
		 * @param {String} str
		 * @param {Integer} limit 
		 * @return {String}
		 **/
		_truncateWords(str, limit) {
			return str.split(" ").splice(0, limit).join(" ");
		},
		
		/**
		 * Event callback for Theme Editor `section:unload` event
		*/
		onUnload: function() {
			this.$container.off(this.namespace);
		}
	});
	
	return ProductsRelated;
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
	var $newAddressForm = $('#AddressNewForm');
	
	if (!$newAddressForm.length) return;
	
	// Initialize observers on address selectors, defined in shopify_common.js
	if (Shopify) {
		new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
			hideElement: 'AddressProvinceContainerNew'
		});
	}
	
	// Initialize each edit form's country/province selector
	$('.address-country-option').each(function() {
		var formId = $(this).data('form-id');
		var countrySelector = 'AddressCountry_' + formId;
		var provinceSelector = 'AddressProvince_' + formId;
		var containerSelector = 'AddressProvinceContainer_' + formId;
		
		new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
				hideElement: containerSelector
			});
		});
		
		// Toggle new/edit address forms
		$('.address-new-toggle').on('click', function() {
			$newAddressForm.toggleClass('d-block');
		});
		
		$('.address-edit-toggle').on('click', function() {
			var formId = $(this).data('form-id');
			$('#EditAddress_' + formId).toggleClass('d-block');
		});
		
		$('.address-delete').on('click', function() {
			var $el = $(this);
			var formId = $el.data('form-id');
			var confirmMessage = $el.data('confirm-message');
			if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
				Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
			}
		});
})();
/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('d-none');
    $('#CustomerLoginForm').toggleClass('d-none');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('d-none');
  }
})();


$(document).ready(function() {
	// DETECT IE11
	var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
	if (isIE11 == true) $('#IE11Modal').modal('show');
	
	var sections = new slate.Sections();
	sections.register('product', theme.Product);
	sections.register('cart', theme.Cart);
	sections.register('productsRelated', theme.ProductsRelated);
	
	// Common a11y fixes
	slate.a11y.pageLinkFocus($(window.location.hash));
	$('.in-page-link').on('click', function(evt) {
		slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
	});
	
	// Target iframes to make them responsive
	var iframeSelectors = '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"]';
	
	slate.rte.wrapIframe({
		$iframes: $(iframeSelectors),
		iframeWrapperClass: 'rte__video-wrapper'
	});
	
	// Apply a specific class to the html element for browser support of cookies.
	if (slate.cart.cookiesEnabled()) {
		document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
	}
});


//====================================== //
//================ THEME =============== //
//====================================== //

/*
	Caching dom elements
*/
theme.selectors = function() {
	theme.cache = {
		$body					: $('html, body'),
		$actualPage				: $('body'),
		$menu					: $('nav.menu'),
		$searchForm				: $('[data-search-form]'),
		$searchInput			: $('[name="q"]'),
		$searchIconMenu			: $('[data-search-icon]'),
		$searchPredictions		: $('[data-search-predictions]'),
		$heroHome				: $('.template-index .hero'),
		$toScroll				: $('[data-to-scroll]'),
		$heroHomeVideo			: $('[hero-home-video]'),
		$slickHero				: $('#slick-hero'),
		$slickPartners			: $('#slick-partners'),
		$footerAccordion		: $('footer .accordion .collapse'),
		$secondaryNav			: $('#secondary-nav'),
		viewportWidth			: document.documentElement.clientWidth,
		sm						: 576,
		md						: 768,
		lg						: 992,
		xl						: 1200
	};
}


/**
	* Init key functions
**/
theme.init = function() {
	theme.selectors();
	theme.menuActive()
	theme.scrollToTarget();

	// Homepage
	if (theme.cache.$actualPage.hasClass('template-index')) {
		if (theme.cache.viewportWidth >= theme.cache.lg) { theme.iosBadVH(); }
	}
	
	// Secondary Nav Dropdown
	if (theme.cache.$secondaryNav.length)
		theme.secondaryNavToggle(); 

	// Window resize
	theme.windowResize();

	//Search
	theme.liveSearch();

	// All pages
	theme.accordionFoooterResize();
	
	// Index and Collection pages
	if (theme.cache.$actualPage.hasClass('template-index') || theme.cache.$actualPage.hasClass('template-collection') || theme.cache.$actualPage.hasClass('template-list-collections')) {
		$('[data-url-link]').on('click', function(e) {
			e.preventDefault();
			var url = $(this).data('url-link');
			if (url) window.location.href = url;
		});
	}
	
	// FORMS validation
	var $forms = theme.cache.$actualPage.find('form[data-validate="true"]')
	if ( $forms.length ) {
		theme.formsValidation($forms);
	}

}


theme.windowResize = function() {
	$(window).on('resize', function() {
		theme.cache.viewportWidth = document.documentElement.clientWidth;
		theme.menuActive();

		theme.accordionFoooterResize();
	});
}

/* *****************************************
	MENU
****************************************** */
theme.menuActive = function() {
	// Active only for lg+ devices
	if (theme.cache.viewportWidth < theme.cache.lg) return;
	var caretPos = 0,
	  $subMenus = $('.submenu');
	
	// TOGGLE SUBMENU
	function toggleSubMenu (e) {
		var $parent = $(e.target),
		  $subMenu = $('[data-submenu="'+e.target.id+'"]');
		
		setTimeout(function() {
			var couldOpen = e.type !== 'click' && $parent.is(':hover'),
			  outsideSubMenu = (!$subMenu.length || e.type == 'mouseout') ? true : false, 
			  show = couldOpen || !outsideSubMenu;

			if (show) {
				$subMenus.removeClass('show')
				$subMenu.addClass('show');
				// Caret position
				var $target = $(e.currentTarget);
				caretPos = $target.offset().left + $target.width()/2;
				$subMenu.find('.caret').css({ left: caretPos });				
			} else {
				$('[data-submenu]').removeClass('show');
			}
		}, 40);
	}

	// Events
	if ( theme.cache.viewportWidth >= theme.cache.lg ) {
		// ENTER MAIN MENU
		$('body').on('mouseenter', '.menu .main-nav-lg .parent', toggleSubMenu);
		// EXIT SUB MENU
		$('body').on('mouseleave', '.menu .submenu', toggleSubMenu);
		
		// EXIT MAIN MENU
		$('body').on('mouseleave', '.menu .main-nav-lg', function(e) {
			var $nav = $(e.currentTarget),
			  w = ~~$nav.outerWidth(), 
			  h = ~~$nav.outerHeight(), 
			  navOffset = $nav.offset(),
			  x = ~~e.pageX - ~~navOffset.left, 
			  y = ~~e.pageY - ~~navOffset.top;
	
			// X axis
			if ( x < 0 || x > w )
				$('[data-submenu]').removeClass('show');
			
			// X axis
			if ( y < 0 )
				$('[data-submenu]').removeClass('show');
		});
	}
}

/* *****************************************
	SECONDARY NAV
****************************************** */
theme.secondaryNavToggle = function() {
	var controller, scene, $overlay;
	
	// init controller 
	controller = new ScrollMagic.Controller();
	
	// sticky nav 
	scene = new ScrollMagic.Scene({triggerElement: "#secondary-nav-wrap"})
		scene.triggerHook(0)
		.setPin("#secondary-nav-wrap")
		.addTo(controller);

	$overlay = theme.cache.$secondaryNav.find('.overlay');
	
	theme.cache.$secondaryNav.on('click', 'a[data-more-button]' , function(e) {
		e.preventDefault();
		$overlay.toggleClass('d-none');
	});
	
	// On mobile close the secondary nav after item click (scroll)
	theme.cache.$secondaryNav.on('click', '.overlay-col-1 a:not([data-more-button])' , function(e) {
		$overlay.toggleClass('d-none');
	});
}

/* *****************************************
	LIVE SEARCH
****************************************** */
theme.liveSearch = function() {
	var cleared = false, timeoutSpeed = 400, $form = theme.cache.$searchInput.parents('form'), context = null, activeForm = null;
	var $iconSwitch = $form.find('[data-search-icons-switch] i');

	// Search option
	var data = {
		s: null,
		resources: { types: ['product'], limit: 4, 
			options: {
				unavailable_products: "hide",
				fields: "title,body,product_type,variants.title,tag"
			}
		}
	};

	// Size the search result box
	if ( theme.cache.$searchPredictions.hasClass('is-homepage') ) {
		var w = theme.cache.$searchInput.filter('[data-is-homepage]').outerWidth();
		theme.cache.$searchPredictions.css({ 'max-width': w })
	}

	var success = function(r) {
		// Check if the research was cleared by the user
		if (cleared) return;
		
		// Re-desfine the Icons scope for the active search form
		$iconSwitch = activeForm.find('[data-search-icons-switch] i');
		
		// Reset var
		var html = '';

		// If array of products is zero, display no results
		if (r.resources.results.products.length > 0) {
			var html = '<div class="list px-3 py-lg-3">';	
			$.each(r.resources.results.products, function(index, product) {
				html += '<a href="'+product.url+'" title="'+product.title+'" class="py-2 d-block">'+product.title+'</a>'; 
			});
			// Close .list div
			html += '</div>'
		}
		
		theme.cache.$searchPredictions.filter('[data-search-predictions="'+context+'"]').removeClass('off fade-out').addClass('on').html(html);
		
		// Switch search icons
		switchSearchIcons(0);
	}
	
	var fail = function(r) { console.log('fail', r); }
	
	
	// On search when user releases a key trigger ajax function for searching recommended product results
	theme.cache.$searchInput.on('keyup', function(e) {
		var value = $(this).val();
		
		activeForm = $(this).parents('form');
		
		// Set context
		context = $(this).data('context');
		
		// if value is >= 2, call ajax function to get data.
		if (value.length >= 2) {
			// Reset cleared status
			cleared = false; data.s = value;
			theme.ajax({ method: 'GET', url: '/search/suggest.json' }, data, success, fail);
		// if value is less than 2 show
		} else {
			closeSearchResults();
		}
	});

	theme.cache.$searchInput.on('search', closeSearchResults() );
	
	
	// Reset Search input and list on Desktop
	/*
	theme.cache.$searchIconMenu.on('mouseenter', function(e) {
		e.preventDefault();
		theme.cache.$searchPredictions.empty();
		theme.cache.$searchInput.val(null);
	});
	*/
	
	
	// When the imput is not on focus anymore the results disappear
	theme.cache.$searchInput.on('blur', function(e) { 
		cleared = true;
		context = null;
		theme.cache.$searchPredictions.removeClass('on').addClass('off');
		
		// Switch search icons
		switchSearchIcons(0);
	});

	
	/**
	 * Close Search Results
	**/
	function closeSearchResults() {
		cleared = true;
		context = null;
		theme.cache.$searchPredictions.removeClass('on').addClass('off');
		
		// Switch search icons
		switchSearchIcons(1);
	}
	
	
	/**
	 * Add event listner to close the result box
	**/
	$iconSwitch.on('click', function(e) {
		if ( $(e.currentTarget).attr('data-function-close') == 'true' ) {
			e.preventDefault();
		
			theme.cache.$searchPredictions.removeClass('on').addClass('off');
			
			// Switch search icons
			switchSearchIcons(1);
			
			// Clear search value
			theme.cache.$searchInput.val(null);
		}
	});
	
	
	/**
	 * Switch icons in the search bar
	 * status : 0 == initial states, 1 == active search state
	 *
	 * @param {integer} status 
	 *
	**/
	function switchSearchIcons(status) {
		// Switch search icons
		if (status === 1) {
			$iconSwitch.filter(':odd').addClass('off');
			$iconSwitch.filter(':even').removeClass('off');
		} else {
			$iconSwitch.filter(':even').addClass('off');
			$iconSwitch.filter(':odd').removeClass('off');
		}
	}
}

/* *****************************************
	FORMS VALIDATION
***************************************** */
/**
 * Form validation - using parsley
**/
theme.formsValidation = function($forms) {
	$forms.parsley();
}

/**
 * AJAX calls
**/
theme.ajax = function(options, data, callback, callbackFail) {
	var com;
	// Set up defaults
	if (!options) return false;
	// Setup Ajax
	$.ajaxSetup(options);
	
	if (options.dataType == 'jsonp')
		com = $.ajax({ data: data });
	else if (options.data)
		com = $.ajax();	
	else
		com = $.ajax({ data: data });
	
	com.done(function(res) {
		if (callback)
			return callback(res);
	})
	.fail(function(jqXHR, textStatus, errorThrown) {
		if (callbackFail)
			return callbackFail;
	});
}

/**
 * Open accordion in footer
 * for lg device
**/
theme.accordionFoooterResize = function() {
	if (theme.cache.viewportWidth >= theme.cache.lg) {
		theme.cache.$footerAccordion.collapse('show');
		theme.cache.$footerAccordion.parents('.card').find('button').attr('data-toggle', '');
	} else {
		theme.cache.$footerAccordion.parents('.card').find('button').attr('data-toggle', 'collapse');
		theme.cache.$footerAccordion.collapse('hide');
	}
}

/**
 * Fix iOS bug in CSS vh
**/
theme.iosBadVH = function() {
	// fix iOS bug in CSS vh
	// https://gist.github.com/pburtchaell/e702f441ba9b3f76f587
	var isBadIos = function() {
		var regex = /(iPhone|iPad|iPod);[^OS]*OS (\d)/;
		var matches = navigator.userAgent.match(regex);
		if (!matches) return false;
			return matches[2] < 8;
	}
	
	if (isBadIos()) {
		var h = document.documentElement.clientHeight || 0;
		if (h && !theme.cache.$heroHome.hasClass('hero-for-video')) theme.cache.$heroHome.height(h+1);
	}
}

/**
 * Scroll to anchor
**/
theme.scrollToTarget = function() {
	theme.cache.$toScroll.on('click', function(e) {
		var target = $(this).data('scroll-target') || null,
		  s = $(this).data('scroll-speed') || null;
		  o = $(this).data('scroll-offset')*1 || 0;

		if (target) theme.scroller(target, s, o);
	});
}

/**
 * Scroller
**/
theme.scroller = function(hash, duration, offset, cb) {
	var target = $(hash+':visible'),
	dur = duration || 1200
	off = (typeof offset != 'undefined') ? offset : 0;

	if (target.length) {
		theme.cache.$body.animate({
			scrollTop: target.offset().top + off
		}, dur, 'easeInCubic')
		.promise().done(cb);
	}
	return false;
}


// Helper
jQuery.extend(jQuery.easing, {
	easeInCubic: function (x, t, b, c, d) {
		return c*(t/=d)*t*t + b;
	},
	easeOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
	}
});


/** * INIT * **/
$(theme.init());